import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
@Directive({
    selector: '[appDecimalNumber]'
})
export class DecimalNumberDirective {
    @Input() maxDecimalDigits: number = 3;
    private regex: RegExp = new RegExp(/^\d*\.?\d{0,3}$/g);
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];
    constructor(
        private el: ElementRef,
        private control: NgControl
    ) { }
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        const next: string = [
            current.slice(0, position),
            event.key,
            current.slice(position)
        ].join('');
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
    @HostListener('blur', ['$event'])
    onBlur(event: FocusEvent) {
        this.formatValue();
    }
    private formatValue(): void {
        let value = this.el.nativeElement.value;
        if (value && value.includes('.')) {
            const parts = value.split('.');
            if (parts[1].length > this.maxDecimalDigits) {
                value = `${parts[0]}.${parts[1].substring(0, this.maxDecimalDigits)}`;
                this.control.control?.setValue(value);
            }
        }
    }
    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const pastedInput = event.clipboardData?.getData('text/plain').replace(/[^0-9.]/g, '');
        if (pastedInput) {
            const currentValue = this.el.nativeElement.value;
            const newValue = currentValue + pastedInput;
            if (newValue.match(this.regex)) {
                this.control.control?.setValue(newValue);
            }
        }
    }
}